/** The Object Explorer context menu's glyphs, by the `icon` key a `ContextMenuAction` carries. */
import type React from 'react';
import {
  Activity,
  ArrowLeft,
  ArrowRight,
  BarChart3,
  Bug,
  BugPlay,
  Clipboard,
  Code,
  Copy,
  DatabaseBackup,
  Delete,
  Download,
  Edit,
  ExternalLink,
  FileCode,
  FilePlus,
  FileText,
  FolderGit2,
  GitCompare,
  HardDrive,
  Info,
  Link2,
  Maximize2,
  Map,
  PackageSearch,
  Camera,
  FolderOpen,
  Gauge,
  Globe,
  KeyRound,
  MessageSquare,
  Pin,
  PinOff,
  Terminal,
  Trash2,
  Play,
  PlugZap,
  Plus,
  PowerOff,
  RefreshCw,
  Search,
  Sparkles,
  Table,
  Lock,
  Trash,
  Upload,
  Users,
  FileSearch,
} from 'lucide-react';

export const ACTION_ICON_MAP: Record<string, React.ElementType> = {
  'refresh': RefreshCw,
  'edit': Edit,
  'table': Table,
  'code': Code,
  'file-code': FileCode,
  'file-text': FileText,
  'search': Search,
  'trash': Trash,
  'file-plus': FilePlus,
  'plus': Plus,
  'folder-git-2': FolderGit2,
  'delete': Delete,
  'play': Play,
  'maximize': Maximize2,
  'download': Download,
  'upload': Upload,
  'power-off': PowerOff,
  'plug-zap': PlugZap,
  'hard-drive': HardDrive,
  'link-2': Link2,
  'git-compare': GitCompare,
  'arrow-right': ArrowRight,
  'arrow-left': ArrowLeft,
  'info': Info,
  'clipboard': Clipboard,
  'copy': Copy,
  'users': Users,
  'lock': Lock,
  'activity': Activity,
  'database-backup': DatabaseBackup,
  'bug': Bug,
  'bug-play': BugPlay,
  'package-search': PackageSearch,
  'bar-chart': BarChart3,
  'file-search': FileSearch,
  'pin-off': PinOff,
  'map': Map,
  'sparkles': Sparkles,
  // C2 N16: the storage tree menus use the storage row / More menus' glyphs.
  'trash-2': Trash2,
  'key': KeyRound,
  'camera': Camera,
  'gauge': Gauge,
  'terminal': Terminal,
  'folder-open': FolderOpen,
  'message-square': MessageSquare,
  'pin': Pin,
  // Last UI/UX pass (F4): the container menu's public access level, and the portal link (Copy URL keeps link-2).
  'globe': Globe,
  'external-link': ExternalLink,
};
